import { render } from "./PropertyDescription.vue?vue&type=template&id=49549702&scoped=true"
import script from "./PropertyDescription.vue?vue&type=script&lang=js"
export * from "./PropertyDescription.vue?vue&type=script&lang=js"

import "./PropertyDescription.vue?vue&type=style&index=0&id=49549702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49549702"]])

export default __exports__